import { render } from "./index.vue?vue&type=template&id=9786ec9e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=9786ec9e&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9786ec9e"],['__file',"src/components/TopBar/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9786ec9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9786ec9e', __exports__)) {
    console.log('reload')
    api.reload('9786ec9e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=9786ec9e&scoped=true", () => {
    console.log('re-render')
    api.rerender('9786ec9e', render)
  })

}


export default __exports__